<div class="card animated fadeInLeftBig">
    <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
    <div class="card-body">
      <div *ngIf="joseToken && joseToken.message" class="regulatory_body_card">
        <iframe width="100%" height="100%" [src]="streamlitUrl | safe"></iframe>
      </div>
    </div>
  </div>
